import React from 'react';
import PropTypes from "prop-types";
import { StyledStatusCopy } from './styled';

const StatusCopy = ({ children, value, customStyle }) => {
    return (
        <StyledStatusCopy
            value={value}
            customStyle={customStyle}
        >
            {children}
        </StyledStatusCopy>
    );
};

StatusCopy.propTypes = {
    children: PropTypes.node,
    value: PropTypes.number,
    customStyle: PropTypes.array
};

StatusCopy.defaultProps = {
    value: 0
};

export default React.memo(StatusCopy);
